<div fxLayout="column" class="layout-wrapper"
    [ngClass]="{'layout-wrapper-menu-active':sidebarActive,'layout-overlay-menu':overlay}">

    <!--layout-blue.css .layout-wrapper .topbar {height: 60px;}-->
    <app-home-topbar></app-home-topbar>
    <app-home-sidebar fxFlex="0 0 60px"></app-home-sidebar>
    <div *ngIf="startupComplete" fxFlex="1 1 auto" fxLayout="column" class="liquitics-layout-content">
        <!--<div fxFlex="100%-60px" class="layout-content">-->
        <!-- <app-dashboard fxFlex="1 1 100%"></app-dashboard> -->
        <app-survival-horizon *ngIf="profileFamily === 'SURVIVAL_HORIZON'"></app-survival-horizon>
        <app-risk-manager *ngIf="profileFamily === 'RISK_MANAGER'"></app-risk-manager>
        <app-alm-manager *ngIf="profileType === 'ALM_MANAGER'"></app-alm-manager>
        <app-alm-trader *ngIf="profileType === 'ALM_TRADER'"></app-alm-trader>
        <!-- <app-eod *ngIf="profileFamily === 'OPERATIONS'"></app-eod> -->
        <app-report-dashboard *ngIf="profileType === 'REPORTING'"></app-report-dashboard>
        <app-operations *ngIf="profileType === 'OPERATIONS'"></app-operations>
    </div>

    <div *ngIf="!startupComplete && !isLoggedOut" class="splash-screen">
        <!--<div class="splash-loader"></div>-->
        <img *ngIf="!startupFailed" class="splash-logo" align="center" height="40px" src="assets/liquitics-logo.svg" />
        <mat-icon *ngIf="startupFailed" class="startup-failure-logo" align="center" height="40px">report</mat-icon>
        <div>
            <ul class="startup-progress">
                <li *ngFor="let message of startupMessages">{{message}}</li>
            </ul>
        </div>
    </div>
    <app-home-footer></app-home-footer>
</div>